<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form">
      <el-form-item prop="email" :label="$t('authPage.emailLabel')">
        <el-input
          v-model="form.email"
          data-test="email-input"
          :placeholder="$t('authPage.emailLabel')">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          v-loading="loading"
          data-test="submit-button"
          type="success" style="width: 100%;"
          @click="submit">
          {{ $t('authPage.submitButtonText') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        rules: {
          email: [
            {
              required: true,
              message: this.$t('commons.defaultErrorMessage'),
              trigger: 'blur',
            },
          ],
        },
        form: {
          email: '',
        },
      };
    },
    methods: {
      submit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.bakeryAuth(this.form.email);
          }
        });
      },
      async bakeryAuth(email) {
        this.loading = true;
        try {
          await this.$store.dispatch('bakeryAuthService/sendEmailToGetMagicToken', email);
          this.$emit('onLogin');
          this.showSuccessMessage();
        } catch (e) {
          this.showErrorMessage();
        }
        this.loading = false;
      },
      showSuccessMessage() {
        this.$message({
          type: 'success',
          message: this.$t('authPage.checkEmail'),
        });
      },
      showErrorMessage() {
        this.$message({
          type: 'error',
          message: this.$t('commons.defaultErrorMessage'),
        });
      },
    },
  };
</script>
